import { store } from '../store'
import waitForAuthReady from './wait-for-auth'

// Guards the AEI screens. Besides requiring authentication, it ensures the user
// actually has an AEI device, so a direct link to an AEI route cannot be used
// to reach it from an Inobram-only account.
export default async (to, from, next) => {
  // Wait for Firebase to restore the persisted session before deciding, so a
  // hard refresh on this deep link doesn't redirect an authenticated user.
  await waitForAuthReady()

  if (!store.getters.user) {
    next({ path: '/signin', query: { redirect: to.fullPath } })
    return
  }

  // AEI devices are loaded on sign-in, but a deep link may resolve before that
  // request settles; make sure we have an answer before deciding. AEI access
  // follows device model, so a customer whose plan was revoked still reaches
  // these screens and sees that the plan is inactive.
  if (!store.getters.aeiHousesLoaded) {
    await store.dispatch('loadAeiHouses')
  }

  if (store.getters.hasAeiFeature) {
    next()
  } else {
    next('/dashboard')
  }
}



// WEBPACK FOOTER //
// ./src/router/aei-guard.js